import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';

import { DatosContacto } from '../datos-contacto.model';
import { TelefonosFormComponent } from '../../telefonos/components/telefonos-form.component';
import { Telefono, TelefonoFormInput } from '../../telefonos/telefonos.model';
import { emailValidator } from 'projects/registro-personas-empresas/src/app/shared/validators/email-validators';

@Component({
  selector: 'rpe-datos-contacto-form',
  templateUrl: './datos-contacto-form.component.html',
  styleUrls: ['./datos-contacto-form.component.css']
})
export class DatosContactoFormComponent implements OnInit {
  @Input()
  set formInput(dc: DatosContacto) {
    if (dc != null) {
      this._datosContacto = dc;
      this.resetDatosContacto();
      this.setValues(this._datosContacto);
    }
  }
  get formInput(): DatosContacto {
    return this._datosContacto;
  }
  @Output() formValueChanges = new EventEmitter<DatosContacto>();
  @Output() formStatusChanges = new EventEmitter<string>();
  @ViewChild("telefonosForm") private telefonosForm: TelefonosFormComponent

  datosContactoFormGroup: FormGroup = this.fb.group({
    correos_electronico: this.fb.array([])
  });
  _datosContacto: DatosContacto;
  primeraVez = true;

  @ViewChild(TelefonosFormComponent, { static: true })
  telefonosFormComponent: TelefonosFormComponent;
  formInputTelefono: TelefonoFormInput;
  telefonosStatus: string;
  telefonos: Telefono[];

  constructor(private fb: FormBuilder) {
    this.agregarOtroCorreoElectronico();
  }

  ngOnInit(): void {
    this.datosContactoFormGroup.valueChanges.subscribe((_) => {
      this.updateValues();
    });
    this.datosContactoFormGroup.statusChanges.subscribe((_) =>
      this.updateStatus()
    );
  }

  updateValues() {
    this.formValueChanges.emit({
      ...this.datosContactoFormGroup.value,
      telefonos: this.telefonos
    });
  }

  updateStatus() {
    const retStatus =
      this.datosContactoFormGroup.valid && this.telefonosStatus == 'VALID'
        ? 'VALID'
        : 'INVALID';
    this.formStatusChanges.emit(retStatus);
  }

  resetDatosContacto(): void {
    this.correos_electronico().clear({ emitEvent: false });
  }

  correos_electronico(): FormArray {
    return this.datosContactoFormGroup.get('correos_electronico') as FormArray;
  }

  agregarOtroCorreoElectronico() {
    const fcTP = this.fb.group({
      id: [, []],
      direccion: ['', [Validators.required, emailValidator]]
    });
    this.correos_electronico().push(fcTP);
  }
  eliminarUnCorreoElectronico(index: number) {
    this.correos_electronico().removeAt(index);
  }

  checkErrors() {
    this.telefonosForm?.telefonosFormGroup?.markAllAsTouched();
    this.datosContactoFormGroup?.markAllAsTouched();
  }

  setValues(dc: DatosContacto) {
    if (dc) {
      this.formInputTelefono = {
        defaultPais: null,
        preSelectPais: 'uy',
        telefonos: dc.telefonos
      };
      this.telefonos = dc.telefonos;

      if (dc.correos_electronico) {
        dc.correos_electronico.forEach((ce) => {
          const correoForm = this.fb.group({
            id: [ce.id, []],
            direccion: [ce.direccion, [Validators.required, emailValidator]]
          });
          this.correos_electronico().push(correoForm, { emitEvent: false });
        });
      } else {
        this.agregarOtroCorreoElectronico();
      }
    }
    // Luego de crear emito status
    this.formStatusChanges.emit(this.datosContactoFormGroup.status);
  }

  //Telefonos
  telefonoFormValueChange(telefonos: any) {
    this.telefonos = telefonos;
    this.updateValues();
  }

  telefonoFormStatusChange(s: any) {
    this.telefonosStatus = s;
    this.updateStatus();
  }
}
